import React from 'react'

export const LevelEducation = [
  {
    name: 'list',
    component: React.lazy(() => import('modules/admin/pedagogical-parameters/levelEducation/LevelEducationList')),
    path: '/admin/pedagogical-parameters/level-Education',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('modules/admin/pedagogical-parameters/levelEducation/LevelEducationCreate')),
    path: '/admin/pedagogical-parameters/level-Education/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('modules/admin/pedagogical-parameters/levelEducation/LevelEducationEdit')),
    path: '/admin/pedagogical-parameters/level-Education/edit/:levelEducationId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
